"use strict";

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropsFilterSlider = exports.getPropsFilterRange = exports.getPropsFilterList = exports.getPropsShared = exports.getPropsReact = exports.getPropsResults = exports.getPropsFilterGroupOption = exports.getPropsFilterGroup = void 0;

var reactivesearch_1 = require("@appbaseio/reactivesearch");

var components_1 = require("../components");

var getPropsFilterGroup = function getPropsFilterGroup(options) {
  return [].concat(_toConsumableArray(options.filterGroup.options.map(function (filterGroupOption) {
    return (0, exports.getPropsFilterGroupOption)(options, filterGroupOption);
  })), [(0, exports.getPropsResults)(options)]);
};

exports.getPropsFilterGroup = getPropsFilterGroup;

var getPropsFilterGroupOption = function getPropsFilterGroupOption(options, filterGroupOption) {
  var filterProps = {};

  if (filterGroupOption.displayType === "slider") {
    filterProps = (0, exports.getPropsFilterSlider)(filterGroupOption);
  }

  if (filterGroupOption.displayType === "single" || filterGroupOption.displayType === "multi") {
    if (filterGroupOption.displayView === "range") {
      filterProps = (0, exports.getPropsFilterRange)(filterGroupOption);
    } else {
      filterProps = (0, exports.getPropsFilterList)(filterGroupOption);
    }
  }

  var sharedProps = (0, exports.getPropsShared)(options, filterGroupOption);
  return Object.assign(Object.assign({}, sharedProps), filterProps);
};

exports.getPropsFilterGroupOption = getPropsFilterGroupOption;

var getPropsResults = function getPropsResults(options) {
  var _a, _b;

  var includeFieldsProp = function () {
    var _a;

    return [].concat(_toConsumableArray((_a = options.includeFields) !== null && _a !== void 0 ? _a : []), ["id", "title", "type", "handle", "image", "variants.id", "variants.presentment_prices", "callout"]);
  }();

  var excludeFieldsProp = function () {
    var _a;

    return _toConsumableArray((_a = options.excludeFields) !== null && _a !== void 0 ? _a : []);
  }();

  return {
    size: options.filterGroup.pageSize,
    URLParams: true,
    showLoader: false,
    dataField: "title",
    showResultStats: false,
    react: (0, exports.getPropsReact)(options),
    includeFields: includeFieldsProp,
    excludeFields: excludeFieldsProp,
    // scrollTarget: options.scrollTarget,
    componentId: "page",
    scrollOnChange: false,
    pagination: ((_a = options.filterGroup) === null || _a === void 0 ? void 0 : _a.paginationType) !== "infinite_scroll",
    infiniteScroll: ((_b = options.filterGroup) === null || _b === void 0 ? void 0 : _b.paginationType) === "infinite_scroll",
    renderNoResults: function renderNoResults() {
      return null;
    },
    source: reactivesearch_1.ReactiveList
  };
};

exports.getPropsResults = getPropsResults;

var getPropsReact = function getPropsReact(options, filterGroupOption) {
  var sensorIds = (0, components_1.SENSOR_IDS)(options.mode, options.config);

  var reactProp = function () {
    var _a, _b, _c;

    if (filterGroupOption === null || filterGroupOption === void 0 ? void 0 : filterGroupOption.settingsShowEmptyValues) {
      return {
        and: sensorIds
      };
    }

    return {
      and: [].concat(_toConsumableArray(sensorIds), _toConsumableArray((_a = options.additionalComponentIds) !== null && _a !== void 0 ? _a : []), _toConsumableArray((_c = (_b = options.filterGroup) === null || _b === void 0 ? void 0 : _b.options.map(function (filter) {
        return filter.handle;
      })) !== null && _c !== void 0 ? _c : [])).filter(function (handle) {
        return handle !== (filterGroupOption === null || filterGroupOption === void 0 ? void 0 : filterGroupOption.handle);
      })
    };
  }();

  return reactProp;
};

exports.getPropsReact = getPropsReact;

var getPropsShared = function getPropsShared(options, filterGroupOption) {
  var reactProp = (0, exports.getPropsReact)(options, filterGroupOption);

  var nestedFieldProp = function () {
    var nestedFields = ["variants"];
    var topField = filterGroupOption.field.split(".")[0];

    if (nestedFields.includes(topField)) {
      return topField;
    }

    return undefined;
  }();

  var customQueryProp = function () {
    if (!filterGroupOption.settingsHideUnavailable || !filterGroupOption.field.startsWith("variants.")) return undefined;
    return function (value) {
      if (!value) return {}; // reactivesearch sometimes returns string, sometimes string[]

      var valueArray = "string" === typeof value ? [value] : value;
      if (0 === valueArray.length) return {};
      return {
        query: {
          nested: {
            path: "variants",
            query: {
              bool: {
                must: [{
                  match: {
                    "variants.available": "true"
                  }
                }, {
                  terms: _defineProperty({}, filterGroupOption.field, valueArray)
                }]
              }
            }
          }
        }
      };
    };
  }();

  var defaultQueryProp = function () {
    if (!filterGroupOption.field.startsWith("variants.")) {
      return undefined;
    } // override the aggregation query to filter the results by the variants.available attribute


    return function () {
      return {
        aggs: {
          reactivesearch_nested: {
            nested: {
              path: "variants"
            },
            aggs: {
              reactify_nested_outer: {
                filter: {
                  bool: {
                    minimum_should_match: 1,
                    should: [{
                      match: {
                        "variants.available": "true"
                      }
                    }, {
                      match: {
                        "variants.available": filterGroupOption.settingsHideUnavailable ? "true" : "false"
                      }
                    }]
                  }
                },
                aggs: _defineProperty({}, filterGroupOption.field, {
                  terms: {
                    field: filterGroupOption.field,
                    size: 100,
                    order: {
                      _count: "desc"
                    }
                  },
                  aggs: {
                    parent_docs: {
                      reverse_nested: {}
                    }
                  }
                })
              }
            }
          }
        }
      };
    };
  }();

  var sourceProp = function () {
    if (filterGroupOption.displayType === "slider") {
      return reactivesearch_1.ReactiveComponent;
    }

    if (filterGroupOption.displayType === "single") {
      if (filterGroupOption.displayView === "range") {
        return reactivesearch_1.SingleRange;
      }

      return reactivesearch_1.SingleList;
    }

    if (filterGroupOption.displayType === "multi") {
      if (filterGroupOption.displayView === "range") {
        return reactivesearch_1.MultiRange;
      }

      return reactivesearch_1.MultiList;
    }

    return;
  }();

  return {
    URLParams: true,
    componentId: filterGroupOption.handle,
    dataField: filterGroupOption.field,
    filterLabel: filterGroupOption.name,
    nestedField: nestedFieldProp,
    customQuery: customQueryProp,
    defaultQuery: defaultQueryProp,
    source: sourceProp,
    react: reactProp
  };
};

exports.getPropsShared = getPropsShared;

var getPropsFilterList = function getPropsFilterList(filterGroupOption) {
  var _a, _b, _c, _d;

  return {
    size: parseInt(filterGroupOption.displaySize) || undefined,
    queryFormat: (_a = filterGroupOption.settingsFilterLogic) !== null && _a !== void 0 ? _a : "or",
    showFilter: (_b = filterGroupOption.settingsShowFilter) !== null && _b !== void 0 ? _b : true,
    showLoadMore: (_c = filterGroupOption.settingsShowMore) !== null && _c !== void 0 ? _c : false,
    showSearch: (_d = filterGroupOption.settingsShowSearch) !== null && _d !== void 0 ? _d : false,
    showRadio: false,
    showCheckbox: false
  };
};

exports.getPropsFilterList = getPropsFilterList;

var getPropsFilterRange = function getPropsFilterRange(filterGroupOption) {
  var _a, _b;

  var data = function () {
    var _a, _b;

    return (_b = (_a = filterGroupOption.displayRangeOptions) === null || _a === void 0 ? void 0 : _a.map(function (option) {
      var _option$split = option.split(":"),
          _option$split2 = _slicedToArray(_option$split, 3),
          label = _option$split2[0],
          start = _option$split2[1],
          end = _option$split2[2];

      return {
        label: label,
        start: start ? parseInt(start) : 0,
        end: end ? parseInt(end) : Number.MAX_SAFE_INTEGER
      };
    })) !== null && _b !== void 0 ? _b : [];
  }();

  return {
    queryFormat: (_a = filterGroupOption.settingsFilterLogic) !== null && _a !== void 0 ? _a : "or",
    showFilter: (_b = filterGroupOption.settingsShowFilter) !== null && _b !== void 0 ? _b : true,
    showRadio: false,
    showCheckbox: false,
    data: data
  };
};

exports.getPropsFilterRange = getPropsFilterRange;

var getPropsFilterSlider = function getPropsFilterSlider(filterGroupOption) {
  return {};
};

exports.getPropsFilterSlider = getPropsFilterSlider;